import { render, staticRenderFns } from "./AssOrderPage.vue?vue&type=template&id=6d26dea8&"
import script from "./AssOrderPage.vue?vue&type=script&lang=js&"
export * from "./AssOrderPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports